import { Button, Col, Form, Input, Modal, Row } from 'antd'
import client from 'apollo'
import { AppContext } from 'AppContext'
import {
  SEND_OTP_FOR_REEVALUATE,
  VERIFY_OTP_FOR_REEVALUATE,
} from 'modules/Users/graphql/Mutations'
import React, { useContext, useEffect, useState } from 'react'
import openNotification from 'utils/Notification'

const VerificationModal = ({ visible, onNext, onCancel }) => {
  const [secondsLeft, setSecondsLeft] = useState(0)
  const OTP_EXPIRY_KEY = 'otp_expiry_time'
  const OTP_SENT_KEY = 'otp_sent_once'

  const {
    state: { currentUser },
  } = useContext(AppContext)
  const [loadings, setLoadings] = useState()

  const formItemLayout = {
    labelCol: { xs: { span: 24 }, sm: { span: 24 } },
    wrapperCol: { xs: { span: 24 }, sm: { span: 24 } },
  }
  const sendOTP = () => {
    const now = new Date()
    setLoadings(true)

    client
      .mutate({ mutation: SEND_OTP_FOR_REEVALUATE })
      .then((res) => {
        const message = res?.data?.sendOtpForReEvaluate?.note
        let cooldown = 180

        if (message?.includes('Please try after')) {
          const secondsMatch = message.match(/\d+/)
          cooldown = secondsMatch
        }

        openNotification('success', res?.data?.sendOtpForReEvaluate?.message)
        const expiry = new Date(now.getTime() + cooldown * 1000)
        localStorage.setItem(OTP_EXPIRY_KEY, expiry.toISOString())
        localStorage.setItem(OTP_SENT_KEY, 'true')
        setSecondsLeft(cooldown)
      })
      .catch((err) => {
        console.error(err)
        openNotification('error', 'Failed to send OTP')
      })
      .finally(() => setLoadings(false))
  }

  useEffect(() => {
    if (!visible) return

    sendOTP()
    const expiryStr = localStorage.getItem(OTP_EXPIRY_KEY)
    const now = new Date()
    const expiry = expiryStr ? new Date(expiryStr) : null
    const diff = expiry ? Math.floor((expiry - now) / 1000) : 0

    if (!expiryStr || isNaN(diff) || diff <= 0) {
      setSecondsLeft(0)
    } else {
      setSecondsLeft(diff)
    }
  }, [visible])

  useEffect(() => {
    const expiryStr = localStorage.getItem(OTP_EXPIRY_KEY)
    if (expiryStr) {
      const expiry = new Date(expiryStr)
      const now = new Date()
      const diff = Math.floor((expiry - now) / 1000)

      if (!isNaN(diff) && diff > 0) {
        setSecondsLeft(diff)
      } else {
        localStorage.removeItem(OTP_EXPIRY_KEY)
      }
    }
  }, [])

  useEffect(() => {
    if (secondsLeft <= 0) return

    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        const updated = prev - 1
        if (updated <= 0) {
          clearInterval(interval)
          localStorage.removeItem(OTP_EXPIRY_KEY)
        }
        return updated
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [secondsLeft])
  const onFinish = (value) => {
    setLoadings(true)
    const otp = value.otp
    client
      .mutate({ mutation: VERIFY_OTP_FOR_REEVALUATE, variables: { otp: otp } })
      .then((res) => {
        localStorage.removeItem(OTP_EXPIRY_KEY)
        localStorage.removeItem(OTP_SENT_KEY)

        onNext()
        setLoadings(false)
      })
      .catch((err) => console.log(err))
      .finally(() => setLoadings(false))
  }

  return (
    <>
      <Modal
        maskClosable={false}
        visible={visible}
        title={'OTP verification'}
        footer={null}
        closable={true}
        onCancel={() => onCancel()}
      >
        <Form
          {...formItemLayout}
          className='user-form'
          onFinish={onFinish}
          initialValues={{
            email: currentUser.email,
            phone: currentUser.phone,
          }}
        >
          <Row gutter={16}>
            <Col className='gutter-row' xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name='email'
                label='Register Email ID'
                rules={[{ required: true }]}
              >
                <Input placeholder='Enter email' disabled />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className='gutter-row' xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name='phone'
                label='Register Mobile Number'
                rules={[{ required: true }]}
              >
                <Input
                  type='number'
                  style={{ width: '100%' }}
                  placeholder='Enter Mobile Number'
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className='gutter-row' xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name='otp' label='OTP' rules={[{ required: true }]}>
                <Input placeholder='Enter OTP' />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col className='gutter-row' xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item>
                <Button
                  type='primary'
                  htmlType='submit'
                  // disabled={secondsLeft > 0}
                >
                  Submit
                </Button>
              </Form.Item>
              <div>
                {secondsLeft > 0 ? (
                  <span style={{ color: '#af0000' }}>
                    Try again in {Math.floor(secondsLeft / 60)}m{' '}
                    {secondsLeft % 60}s
                  </span>
                ) : (
                  <Button type='primary' onClick={sendOTP} loading={loadings}>
                    Re-Send OTP
                  </Button>
                )}
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  )
}

export default VerificationModal
